import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { createAction } from 'redux-actions';
var getArticlesStart = createAction('GET_GHOST_ARTICLES_START');
var getArticlesSuccess = createAction('GET_GHOST_ARTICLES_SUCCESS', // we need to format the data so that the byId reducer can handle it
function (data) {
  return {
    results: Object.keys(data).filter(function (k) {
      return k !== 'meta';
    }).map(function (k) {
      return data[k];
    }),
    count: data.meta.pagination.total,
    next: data.meta.pagination.next
  };
});
var getArticlesFailure = createAction('GET_GHOST_ARTICLES_FAILURE');
/**
 * Action that handles fetching multiple articles from Ghost.
 *
 * Note that these articles don't have the actual text that users can read. Use `getArticle` to fetch the text on an as-needed basis.
 *
 * ```js
 * // in a component
 * import { ghost } from '@minerva-analytics/pantheon';
 *
 * const ghostApi = new GhostContentAPI({
 *   url: 'https://demo.ghost.io',
 *   key: 'abc123',
 *   version: "v3"
 * });
 *
 * const Test = () => {
 *   const { getArticles } = ghost.hooks.useGhostActions(ghostApi);
 *
 *   return (
 *     <button onClick={getArticles}>Click me</button>
 *   )
 * }
 *
 * // outside of a component
 * import { ghost } from '@minerva-analytics/pantheon';
 *
 * const ghostApi = new GhostContentAPI({
 *   url: 'https://demo.ghost.io',
 *   key: 'abc123',
 *   version: "v3"
 * });
 *
 * const anotherAction = () => async (dispatch) => {
 *   dispatch(ghost.actions.getArticles(ghostApi));
 * };
 * ```
 *
 * @param {GhostContentAPI} ghostApi - An initialized Ghost client library
 *    https://ghost.org/docs/api/v3/javascript/content/#working-example
 *
 * @returns {Function} - A thunk that can be dispatched by redux.
 */

var getArticles = function getArticles(ghostApi) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var page, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (ghostApi) {
                _context.next = 2;
                break;
              }

              throw new Error('getArticles was called without a ghost API. Make sure ' + 'to call getArticles correctly: `getArticles(ghostApi)`');

            case 2:
              if (getState().ghost.getArticlesStatus) {
                _context.next = 4;
                break;
              }

              throw new Error('getArticles was called without the ghost reducers added to project. ' + 'Make sure that all of the reducers for the ghost model are added ' + 'to your store.');

            case 4:
              page = getState().ghost.getArticlesStatus.next || 1;
              dispatch(getArticlesStart());
              _context.prev = 6;
              _context.next = 9;
              return ghostApi.posts.browse({
                page: page,
                include: 'authors'
              });

            case 9:
              data = _context.sent;
              dispatch(getArticlesSuccess(data));
              _context.next = 16;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](6);
              dispatch(getArticlesFailure(_context.t0));

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[6, 13]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

export { getArticles, getArticlesStart, getArticlesSuccess, getArticlesFailure };